import { createAction, props, Action } from '@ngrx/store';
import { IDirectDebitDetails } from '@nx-ng/types';
import { ApiError, DDAccountVerifyResponse } from '../client/src';

export const VERIFY_DIRECT_DEBIT_TYPE =
  '[Direct Debit] Verify Direct Debit API';
export const checkoutAPI_verifyDirectDebitDetails = createAction(
  VERIFY_DIRECT_DEBIT_TYPE,
  props<{ sortCode: string; accountNumber: string; save?: boolean }>()
);

export const checkoutAPI_verifyDirectDebitDetailsSuccess = createAction(
  `${VERIFY_DIRECT_DEBIT_TYPE} Success`,
  props<{ response: DDAccountVerifyResponse }>()
);

export const checkoutAPI_verifyDirectDebitDetailsNotFound = createAction(
  '[Checkout] Verify Direct Debit Not Found API'
);

export const checkoutAPI_verifyDirectDebitDetailsFailure = createAction(
  `${VERIFY_DIRECT_DEBIT_TYPE} Failure`,
  props<{ error?: string | ApiError; retryAction?: Action }>()
);

export const clearDirectDebitVerfification = createAction(
  '[Checkout] Clear Direct Debit Verification'
);

export const saveDirectDebitForm = createAction(
  '[Checkout] Save Direct Debit Form',
  props<{ directDebitForm: IDirectDebitDetails }>()
);
